import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import { DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ShiftData from '../../../assets/data/ShiftData';
import TimezoneData from '../../../assets/data/TimezoneData';
import UserData from '../../../assets/data/UserData';
import EventAddByAdminIcon60pxSvg from '../../../assets/images/icons/EventAddByAdminIcon60pxSvg';
import avatar_2 from '../../../assets/images/logo/avatar-default-logo.png';
import profile from '../../../assets/images/logo/profile.png';
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, GrayIconButton } from '../../../components/StyledButton';
import { CustomDialog, StyledCheckbox } from '../../../components/StyledComponents';
import QuestionIcon16pxSvg from '../../../assets/images/icons/QuestionIcon16pxSvg';
import CustomDatePicker from '../../../components/CustomDatePicker';
import CustomInput from '../../../components/CustomInput';
import CustomSelect from '../../../components/CustomSelect';
import CustomTimePicker from '../../../components/CustomTimePickerHaveSecond';
import DefaultTooltip from '../../../components/DefaultTooltip';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { editEventlogRequest } from '../../../axios/Eventlog/EventLogApi';
import LoopIcon from '@mui/icons-material/Loop';
import { useAuth } from '../../../context/AuthContext';
import { getShiftByUser } from '../../../axios/Shift/ShiftApi';
import dayjs from 'dayjs';

const EditRequestEventDialogByUser = ({ onClose, usersData, shiftsData, onRefresh, info, tabName, parsedNewData, parsedOldData }) => {
   const { t } = useTranslation();
   const { genaralSettingDateFormat, genaralSettingTimeFormat, dateTimeFormat, profile, genaralSettingTimeZone } = useAuth();
   const [shiftsData1, setShiftsData] = useState([]);
   const [loadingCount, setLoadingCount] = useState(0);
   const [isSubmitting, setIsSubmitting] = useState(false);
   const isDialogLoading = loadingCount > 0 || isSubmitting;

   const handleCloseDialog = () => {
      onClose();
   };


   const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({
         ...prevData,
         [name]: value,
      }));
   };


   // const shift = shiftsData.find((item) => item.shiftId === parsedNewData.shiftId);
   // const isEditEvent = info?.requestTypeName === 'EDIT_EVENT_LOG';
   // let time = '';

   // if (info?.requestTypeName === 'EDIT_EVENT_LOG') {
   //    time = parsedNewData?.time || '';
   // } else {
   //    const isCheckIn = parsedNewData?.eventTypeId === 1;
   //    const fullTime = isCheckIn ? parsedNewData?.timeCheckIn : parsedNewData?.timeCheckOut;
   //    time = fullTime?.split(' ')[1] || '';
   // }
   const shift = shiftsData1.find((item) => item.shiftId === parsedNewData.shiftId);
   const isEditEvent = parsedNewData?.date || parsedNewData?.time;
   let time = '';

   if (isEditEvent) {
      time = parsedNewData?.time || '';
   } else {
      const isCheckIn = parsedNewData?.eventTypeId === 1;
      const fullTime = isCheckIn ? parsedNewData?.timeCheckIn : parsedNewData?.timeCheckOut;
      time = fullTime?.split(' ')[1] || '';
   }


   const initialFormData = {
      eventType: parsedNewData?.eventTypeId ? parsedNewData.eventTypeId : 0,
      username: profile.fullName,
      selectDate: !isEditEvent
         ? new Date(parsedNewData?.eventTypeId === 1 ? parsedNewData.timeCheckIn : parsedNewData.timeCheckOut)
         : new Date(parsedNewData?.date),

      selectDateOld: parsedOldData?.eventDate ? new Date(parsedOldData.eventDate) : '',
      selectTime: time ? time : '00:00:00',
      selectTimeOld: parsedOldData?.eventTime ? parsedOldData.eventTime : '',
      timeZone: parsedNewData?.timeZone ? parsedNewData.timeZone : '',
      timeZoneOld: parsedOldData?.timeZone ? parsedOldData.timeZone : '',
      shift: shift ? shift.shiftId : '',
      shiftOld: parsedOldData?.shiftName ? parsedOldData?.shiftName : '',

      descriptionOld: '',
      device: info?.deviceDescription || '',
      description: info?.requestReason,
      userId: profile.userId,
      requestTypeId: 2,
      eventAttendanceId: info.id,
      shiftIdOld: parsedNewData.shiftId,
      typeEdit: info.requestTypeName
   };



   const handleSubmitEditEventLogRequest = async () => {

      const oldDataConvert = {
         ...info,
         eventTypeId: info.eventType === 'CHECK_IN' ? 1 : 2,
         ...(info.eventType === 'CHECK_IN' && { timeCheckIn: `${info.eventDate} ${info.eventTime}` }),
         ...(info.eventType === 'CHECK_OUT' && { timeCheckOut: `${info.eventDate} ${info.eventTime}` }),
      };
      const payload = {
         ...formData,
         selectDate: format(formData.selectDate, 'yyyy-MM-dd'),
         selectDateOld: format(formData.selectDateOld, 'yyyy-MM-dd'),
         oldData: JSON.stringify(oldDataConvert),
         langId: localStorage.getItem("i18nextLngId")
      };

      // const payload = {
      //    ...formData,
      //    selectDate: format(formData.selectDate, 'yyyy-MM-dd'),
      //    // selectDateOld: format(formData.selectDateOld, 'yyyy-MM-dd'),
      //    oldData: info.oldData ? info.oldData : info.newData
      // };

      setIsSubmitting(true);
      try {
         const response = await editEventlogRequest(payload);
         if (response?.data?.responseCode === 0) {
            handleCloseDialog();
            toast.success(t('common.edit-request-successfully'));
            onRefresh();
         } else {
            toast.error(response?.data?.message);
         }
      } catch (error) {
         if (error.response) {
            if (error.response.status !== 401) {
               toast.error(t(error?.response.data));
            }
         } else {
            toast.error(t('common.network-timeout'));
         }
      } finally {
         setIsSubmitting(false);
      }
   };




   const [formData, setFormData] = useState(initialFormData);

   const handleDataChange = (name, newData) => {
      setFormData((prevData) => ({
         ...prevData,
         [name]: newData,
      }));
   };

   const [useDifferentShiftDate, setUseDifferentShiftDate] = useState(false);

   const handleCheckedChange = (event) => {
      setUseDifferentShiftDate(event.target.checked);
   };

   // useEffect(() => {
   //    if(info?.shiftDate){
   //       setUseDifferentShiftDate(true)
   //    } else {
   //       setUseDifferentShiftDate(false)
   //    }

   // }, [info?.shiftDate]);


   // const userData = UserData();
   // const shiftsData = ShiftData();
   const timezoneData = TimezoneData();
   const [imageSrc, setImageSrc] = useState(avatar_2);

   const browserTZ = dayjs.tz.guess();

   const buildAttendanceDateTimeUTC = (date, time) => {
      if (!date || !time || !genaralSettingTimeZone) return null;

      // yyyy-MM-dd theo ngày chọn
      const yyyyMMdd = format(date, "yyyy-MM-dd");

      // Tạo datetime theo timezone công ty
      const companyDateTime = dayjs.tz(
         `${yyyyMMdd} ${time}`,
         "YYYY-MM-DD HH:mm:ss",
         browserTZ
      );

      // Convert về UTC ISO string
      return companyDateTime.utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
   };

   useEffect(() => {
      if (!formData.userId || !formData.selectDate || !formData.selectTime) return;

      const fetchShift = async () => {
         try {
            setLoadingCount((prev) => prev + 1);

            const dateTimeUTC = buildAttendanceDateTimeUTC(
               formData.selectDate,
               formData.selectTime
            );

            const payload = {
               userId: formData.userId,        // ✅ user đang chọn
               dateTime: dateTimeUTC,          // ✅ ISO8601 UTC (+0)
               langId: localStorage.getItem("i18nextLngId"),
            };

            const response = await getShiftByUser(payload);
            setShiftsData(response.data.data || []);
         } catch (error) {
            toast.error(t(error?.response?.data));
         } finally {
            setLoadingCount((prev) => Math.max(prev - 1, 0));
         }
      };

      fetchShift();
   }, [
      formData.userId,
      formData.selectDate,
      formData.selectTime
   ]);


   return (
      <CustomDialog open transitionDuration={300} maxWidth={'xl'} loading={isDialogLoading} onClose={handleCloseDialog} keepMounted>
         <DialogTitle>
            <div className='flex justify-between'>
               <div className='flex items-center gap-4'>
                  <p className='text-xl font-semibold '>{t('common.edit-request')}</p>
               </div>
               <GrayIconButton onClick={handleCloseDialog} disabled={isDialogLoading}>
                  <CloseIcon />
               </GrayIconButton>
            </div>
         </DialogTitle>
         <DialogContent>
            {info.image && (
               <div className='pt-5'>
                  <div className='flex justify-between items-start pb-5'>
                     <div className='p-1 rounded border border-solid border-[#E5E7EB] max-w-40'>
                        <img
                           src={`data:image/png;base64,${info.image}`}
                           alt='avatar'
                           className=''
                        />
                     </div>
                     <div>
                        <img src={profile} alt='profile' className='' />
                     </div>
                  </div>
               </div>
            )}
            <div className='grid grid-cols-12 md:gap-x-5 gap-y-3 pt-3'>
               <div className='col-span-12 flex items-center gap-4'>
                  <label className='w-32'>
                     {t('common.userName')}
                  </label>
                  <div className='flex-1'>
                     <CustomInput
                        name='username'
                        inputType='text'
                        readOnly={true}
                        value={formData.username}
                        handleInputChange={handleInputChange}
                        labelEnable={false}
                        className='w-full'
                        placeholder={t('common.userName')}
                     />
                  </div>
               </div>
               <div className='col-span-12 flex items-center gap-4'>
                  <p className='w-32 flex items-center'>
                     {t('common.event-type')}
                  </p>

                  <div className='flex-1'>
                     <FormControl
                        component='fieldset'
                        className='w-full'
                        sx={{
                           '.MuiFormGroup-root.MuiFormGroup-row': {
                              gap: '20px',
                              alignItems: 'center',
                           },
                        }}
                     >
                        <div className='flex w-full items-center justify-between'>
                           <div className='flex items-center gap-1 uppercase font-medium'>
                              <span
                                 className='w-2 h-2 rounded-full'
                                 style={{
                                    backgroundColor:
                                       parsedNewData?.eventTypeId === 2 ? '#EF4444' : '#86EFAC', // đỏ nếu CHECK_OUT
                                 }}
                              />
                              <span
                                 className='font-bold'
                                 style={{
                                    color:
                                       parsedNewData?.eventTypeId === 2 ? '#EF4444' : '#86EFAC',
                                 }}
                              >
                                 {parsedNewData?.eventTypeId === 2
                                    ? t('attendance.CHECK_OUT')
                                    : t('attendance.CHECK_IN')}
                              </span>
                           </div>

                           <div className='ml-auto'>
                              <RadioGroup
                                 row
                                 aria-label='Event type'
                                 name='eventType'
                                 value={formData.eventType}
                                 onChange={handleInputChange}
                              >
                                 <FormControlLabel
                                    value={1}
                                    control={<Radio size='small' />}
                                    label={t('attendance.CHECK_IN')}
                                 />
                                 <FormControlLabel
                                    value={2}
                                    control={<Radio size='small' />}
                                    label={t('attendance.CHECK_OUT')}
                                 />
                              </RadioGroup>
                           </div>
                        </div>
                     </FormControl>
                  </div>
               </div>

               {info.oldData ? (
                  // Giao diện đầy đủ khi có oldData
                  <>
                     <div className='col-span-12 flex items-center gap-4'>
                        <label className='w-32 shrink-0'>
                           {t('common.date')}
                        </label>
                        <div className='flex gap-4 w-full'>
                           <div className='flex-1'>
                              <CustomDatePicker
                                 name='selectDate1'
                                 value={formData.selectDateOld}
                                 // onChange={(newDate) => handleDataChange('selectDate', newDate)}
                                 readOnly={true}
                                 className='!mt-0 w-full'
                                 disabledOpenPicker={true}
                                 dateFormat={genaralSettingDateFormat}
                              />
                           </div>
                           <div className='flex-1'>
                              <CustomDatePicker
                                 name='selectDate'
                                 value={formData.selectDate}
                                 onChange={(newDate) => handleDataChange('selectDate', newDate)}
                                 readOnly={true}
                                 className='!mt-0 w-full'
                                 dateFormat={genaralSettingDateFormat}
                              />
                           </div>
                        </div>
                     </div>
                     <div className='col-span-12 flex items-center gap-4'>
                        <label className='w-32 shrink-0'>
                           {t('common.content-036')}
                        </label>
                        <div className='flex gap-4 w-full'>
                           <div className='flex-1'>
                              <CustomInput
                                 // name='username'
                                 inputType='text'
                                 readOnly={true}
                                 value={formData.selectTimeOld}
                                 // handleInputChange={handleInputChange}
                                 labelEnable={false}
                                 className='w-full'
                              // placeholder='User name'
                              />
                           </div>
                           <div className='flex-1'>
                              <CustomTimePicker
                                 hoursLabel={false}
                                 secondsEnabled={false}
                                 // readOnly={true}
                                 onTimeChange={handleDataChange}
                                 value={formData.selectTime}
                                 name='selectTime'
                                 maxHours={23}
                              // className='!mt-2'
                              />
                           </div>
                        </div>
                     </div>
                     <div className='col-span-12 flex items-center gap-4'>
                        <label className='w-32 shrink-0'>
                           {t('common.time-zone')}
                        </label>
                        <div className='flex gap-4 w-full'>
                           <div className='flex-1'>
                              <CustomInput
                                 inputType='text'
                                 readOnly={true}
                                 value={formData.timeZoneOld}
                                 labelEnable={false}
                                 className='w-full'
                              />
                           </div>
                           <div className='flex-1'>
                              <CustomSelect
                                 name='timeZone'
                                 value={formData.timeZone}
                                 onChange={handleInputChange}
                                 options={timezoneData}

                              // position="top"
                              />
                           </div>
                        </div>
                     </div>
                     <div className='col-span-12 flex items-center gap-4'>
                        <label className='w-32 shrink-0'>
                           {t('common.shift')}
                        </label>
                        <div className='flex gap-4 w-full'>
                           <div className='flex-1'>
                              <CustomInput
                                 name='username'
                                 inputType='text'
                                 readOnly={true}
                                 value={formData.shiftOld}
                                 // handleInputChange={handleInputChange}
                                 labelEnable={false}
                                 className='w-full'
                                 placeholder={t('common.userName')}
                              />
                           </div>
                           <div className='flex-1'>
                              <CustomSelect
                                 name='shift'
                                 value={formData.shift}
                                 onChange={handleInputChange}
                                 options={shiftsData1}
                                 dataType='shift'
                              />
                           </div>
                        </div>
                     </div>
                  </>
               ) : (
                  // Giao diện chỉ có new khi oldData là null
                  <>
                     <div className='col-span-12 flex items-center gap-4'>
                        <label className='w-32'>
                           {t('common.date')}
                        </label>
                        {/* <div className='flex gap-4 w-full'> */}
                        {/* <div className='flex-1'>
                        <CustomDatePicker
                           name='selectDate1'
                           value={formData.selectDateOld}
                           // onChange={(newDate) => handleDataChange('selectDate', newDate)}
                           readOnly={true}
                           className='!mt-0 w-full'
                           disabledOpenPicker={true}
                        />
                     </div> */}
                        <div className='flex-1'>
                           <CustomDatePicker
                              name='selectDate'
                              value={formData.selectDate}
                              onChange={(newDate) => handleDataChange('selectDate', newDate)}
                              // readOnly={true}
                              className='!mt-0 w-full text-[#171717]'
                              dateFormat={genaralSettingDateFormat}
                           />
                        </div>
                        {/* </div> */}
                     </div>
                     <div className='col-span-12 flex items-center gap-4'>
                        <label className='w-32'>
                           {t('common.content-036')}
                        </label>
                        {/* <div className='flex gap-4 w-full'> */}
                        {/* <div className='flex-1'>
                        <CustomInput
                           // name='username'
                           inputType='text'
                           readOnly={true}
                           value={formData.selectTimeOld}
                           // handleInputChange={handleInputChange}
                           labelEnable={false}
                           className='w-full'
                        // placeholder='User name'
                        />
                     </div> */}
                        <div className='flex-1'>
                           <CustomTimePicker
                              hoursLabel={false}
                              secondsEnabled={false}
                              // readOnly={true}
                              onTimeChange={handleDataChange}
                              value={formData.selectTime}
                              name='selectTime'
                              maxHours={23}
                              className='text-[#171717]'

                           // className='!mt-2'
                           />
                        </div>
                        {/* </div> */}
                     </div>
                     <div className='col-span-12 flex items-center gap-4'>
                        <label className='w-32'>
                           {t('common.time-zone')}
                        </label>
                        {/* <div className='flex gap-4 w-full'> */}
                        {/* <div className='flex-1'>
                        <CustomInput
                           inputType='text'
                           readOnly={true}
                           value={formData.timeZoneOld}
                           labelEnable={false}
                           className='w-full'
                        />
                     </div> */}
                        <div className='flex-1'>
                           <CustomSelect
                              name='timeZone'
                              value={formData.timeZone}
                              onChange={handleInputChange}
                              options={timezoneData}

                           // position="top"
                           />
                        </div>
                        {/* </div> */}
                     </div>
                     <div className='col-span-12 flex items-center gap-4'>
                        <label className='w-32'>
                           {t('common.shift')}
                        </label>
                        {/* <div className='flex gap-4 w-full'> */}
                        {/* <div className='flex-1'>
                        <CustomInput
                           name='username'
                           inputType='text'
                           readOnly={true}
                           value={formData.shiftOld}
                           // handleInputChange={handleInputChange}
                           labelEnable={false}
                           className='w-full'
                           placeholder='User name'
                        />
                     </div> */}
                        <div className='flex-1'>
                           <CustomSelect
                              name='shift'
                              value={formData.shift}
                              onChange={handleInputChange}
                              options={shiftsData1}
                              dataType='shift'
                           />
                        </div>
                        {/* </div> */}
                     </div>
                  </>
               )}




               {/* <div className='col-span-12 flex items-center gap-4'>
                  <label className='w-32'>{t('common.description')}</label>
                  <div className='flex-1'>
                     <CustomInput
                        name='description'
                        inputType='text'
                        value={formData.descriptionOld}
                        labelEnable={false}
                        className='w-full'
                        readOnly={true}
                     />
                  </div>
               </div> */}

               {/* <div className='col-span-12'>
                  <label>{t('common.device')}</label>
                  <CustomInput
                     name='device'
                     inputType='text'
                     value={formData.device}
                     handleInputChange={handleInputChange}
                     labelEnable={false}
                     className='mt-2'
                     placeholder={t('common.device')}
                     readOnly={true}
                  />
               </div> */}
               <div className='col-span-12 flex items-center gap-4'>
                  <label className='w-32'>{t('common.reason')}</label>
                  <div className='flex-1'>
                     <CustomInput
                        name='description'
                        inputType='text'
                        value={formData.description}
                        handleInputChange={handleInputChange}
                        labelEnable={false}
                        className='w-full'
                        placeholder={t('common.reason')}
                     />
                  </div>
               </div>
               {/* <div className='col-span-12 md:col-span-6'>
                  <label>Authentication</label>
                  <p className='mt-2'>[No identification data]</p>
               </div> */}
            </div>
         </DialogContent>
         <DialogActions>
            <div className='flex gap-2 px-4 py-4'>
               <ControlpanelSecondaryButton onClick={handleCloseDialog} disabled={isDialogLoading}>
                  <CloseIcon />
                  <p>{t('button.close')}</p>
               </ControlpanelSecondaryButton>
               <ControlpanelPrimaryButton onClick={(e) => {
                  handleSubmitEditEventLogRequest()
               }} disabled={isDialogLoading} sx={{
                  borderRadius: '10px',
                  textDecoration: 'none'
               }}>
                  <LoopIcon />
                  <p>{t('button.update-request')}</p>
               </ControlpanelPrimaryButton>
            </div>
         </DialogActions>
      </CustomDialog>
   );
};

export default EditRequestEventDialogByUser;
